module.exports = __webpack_public_path__ + "img/note 1.26cc25ee.svg";